import { CommonModule, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'post-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './post-skeleton.component.html',
})
export class PostSkeletonComponent {
@Input() announcement:boolean=false;
@Input() skeletonCount:number=1;
}
